
import React from 'react';
import { LOGO_URL } from '../constants';

interface FooterProps {
  onLinkClick: (type: 'privacy' | 'terms') => void;
}

const Footer: React.FC<FooterProps> = ({ onLinkClick }) => {
  return (
    <footer className="bg-black border-t border-zinc-900 py-16 px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start gap-12">
        <div className="max-w-sm">
          <div className="flex items-center gap-2 mb-6">
            <img 
              src={LOGO_URL} 
              alt="ENACTUS Logo" 
              className="h-6 w-auto" 
            />
            <span className="font-bold text-lg tracking-tighter">ENACTUS YM</span>
          </div>
          <p className="text-zinc-500 text-sm leading-relaxed">
            연세대학교 미래캠퍼스 중앙 소셜벤처 창업 동아리 ENACTUS YM.<br />
            지속 가능한 비즈니스를 통해 더 나은 세상을 만듭니다.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-12 md:gap-24">
          <div>
            <h4 className="text-white font-bold mb-6">Contact</h4>
            <ul className="text-zinc-500 text-sm space-y-3">
              <li>Instagram: future.yonsei.ac.kr</li>
              <li>KakaoTalk: @인액터스YM</li>
              <li>Email: enactusyonseiw@gmail.com</li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold mb-6">Legal</h4>
            <div className="flex flex-col gap-3">
               <button 
                onClick={() => onLinkClick('privacy')}
                className="text-zinc-500 text-sm hover:text-white transition-colors text-left"
               >
                 개인정보처리방침
               </button>
               <button 
                onClick={() => onLinkClick('terms')}
                className="text-zinc-500 text-sm hover:text-white transition-colors text-left"
               >
                 서비스 이용약관
               </button>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-zinc-900 text-center text-zinc-600 text-xs">
        Copyright 2026 ENACTUS YM. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
